
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */
import PropTypes from "prop-types";
import React from "react";
import {
	StyleSheet,
	ScrollView,
} from "react-native";

import BlockView from "../BlockView";

var styles = StyleSheet.create({
	main: {
		flex: 1,
	},
	content: {
		flex: 1,
		transform: [{
			rotateY: "0deg"
		}]
	}
});

export default function MainScroll(props, context) {
	var style = props.style;
	return (
		<ScrollView
			style={[styles.main, style]}
			onScroll={context.timeoutReset}
		>
			<BlockView style={styles.content}>
				{props.children}
			</BlockView>
		</ScrollView>
	);
}

MainScroll.contextTypes = {
	timeoutReset: PropTypes.func
};
